import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";
import Header from "../components/Header";
import Sider from "antd/es/layout/Sider";
import { Layout } from "antd";
import Menu from "../components/Menu";
import { Content } from "antd/es/layout/layout";

const RoutePrivate = ({ sidebar, header, hiddenButtonBack, customContent }) => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      window.location.assign("/login");
    }
  }, [user]);

  return (
    <Layout>
      <Header />
      <Layout>
        <Sider
          style={{ background: "#645A97", minHeight: "calc(100vh - 70px" }}
          width={230}
          trigger={null}
          collapsedWidth={0}
          breakpoint={"xl"}
        >
          <Menu />
        </Sider>
        <Content className="content" style={customContent || {}}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default RoutePrivate;
